import type { RootState } from 'store'

export const getSort = (state: RootState) =>
  typeof state.requests?.sorting === 'string' ? state.requests.sorting : ''
export const getPageInfo = (state: RootState) => state.requests?.pageInfo ?? {}
export const getSelectedItems = (state: RootState) =>
  state.requests?.selectedItems ?? []
export const getLoading = (state: RootState) => state.requests?.loading
export const getError = (state: RootState) => state.requests?.error
export const getItems = (state: RootState) => state.requests?.items
export const getRequest = (state: RootState) => state?.requests?.item ?? null
export const getQuery = (state: RootState) => state?.requests?.query ?? ''
export const getFilters = (state: RootState) => state?.requests?.filters ?? []
